// bao migrate skip
import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-date-time-box";
import "./../../bindings/bao-date-time-picker";
import baoRouter from "./../../services/bao-router";
import "./../../bindings/bao-toolbar2";
import BaoDialog from "./../../factories/bao-dialog";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import GenerictListTab from "./../../factories/generic-list-tab";
class HolidaySchemaSpecialHolidayViewModel extends GenerictListTab {
    CreationWizardHolidayMessage = Bao.Session.GetMessage("msgCreationWizardHoliday");
    HolidaySchema: any;
    YearNumbers: KnockoutObservableArray<Number> = ko.observableArray([]);
    SelectedYear: KnockoutObservable<Number> = ko.observable(null);
    constructor(public TabPage: TabPage, parent: any) {
        super(TabPage, parent);
        this.DialogWidth = 400;
        this.HolidaySchema = parent;
        this.SelectedYear.subscribe(() => {
            if (this.PageIndex() != 0) {
                this.PageIndex(0);
            }
            this.Refresh();
        });
    }
    CustomFilter() {
        var customFilterHashObject = [];
        if (this.SelectedYear() != null) {
            var hashObjectYear: any = {};
            hashObjectYear.Key = 'Year';
            hashObjectYear.Value = this.SelectedYear();
            customFilterHashObject.push(hashObjectYear);
        }
        return customFilterHashObject;
    }
    CustomToolbarClick = (action) => {
        if (this.TabPage.IsActiveTab()) {
            switch (action.ActionKey()) {
                case "HolidaySchemaSpecialHolidayTabCreationWizard":
                    this.CreationWizardHolidayDate();
                    break;
            }
        }
    };
    CreationWizardHolidayDate() {
        var yesNoDialog = new BaoDialog(Bao.Session.ApplicationName, this.CreationWizardHolidayMessage, "yesno");
        yesNoDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                //TODO: Sicherheitsabfrage ob geändert werden soll.
                return Bao.post("HolidaySchemaSpecialHolidayTab/CreationWizardHolidayDate", JSON.stringify({
                    parentId: this.HolidaySchema.HolidaySchemaId(),
                    sessionTabId: this.HolidaySchema.SessionTabId(),
                    countryId: this.HolidaySchema.CountryId(),
                    stateId: this.HolidaySchema.StateId(),
                    filterYear: this.SelectedYear()
                }), () => {
                    this.HolidaySchema.TabPage.DirtyFlag(true);
                    this.Get();
                });
            }
        });
    }
    ;
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        return $.Deferred<boolean>().resolve(true).promise();
    }
    loadFilter() {
        this.TabPage.IsLoading(true);
        return Bao.post("SynosetMasterData/GetYearCollection", JSON.stringify({}), (result) => {
            var DatumAkt = new Date();
            var JahrAkt = DatumAkt.getFullYear();
            for (var r in result) {
                if (result[r].Key != "" && result[r].Key != null)
                    this.YearNumbers.push(result[r].Key);
            }
            this.SelectedYear(JahrAkt);
            this.TabPage.IsLoading(false);
        });
    }
    ;
    loaded() {
        var def = $.Deferred();
        this.loadFilter().then(() => {
            this.Refresh().then(() => {
                def.resolve();
            });
        });
        return def.promise();
    }
}
export default HolidaySchemaSpecialHolidayViewModel;